/* import __COLOCATED_TEMPLATE__ from './about-profile-location-hidden-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();